<template>
	<div class="service-container" style="height: 100%;">
		<div class="slide" id="slide1_1">
			<h1>崇明软壳蟹工厂<div></div></h1>
			<div class="disabled">

        <video id="myVideo1" loop muted data-autoplay playsinline>
          <source src="/cg3.mp4" type="video/mp4">
        </video>
<!--				<div>-->
<!--					<div><img src="../../assets/images/s1.png"></div>-->
<!--					<div class="title">系统化</div>-->
<!--					<div class="p">培训内容覆盖更全面，从基础到高级技巧，接地气的训课程体系</div>-->
<!--				</div>-->

<!--				<div>-->
<!--					<div><img src="../../assets/images/s2.png"></div>-->
<!--					<div class="title">自动化</div>-->
<!--					<div class="p">减少安全员常规培训的繁复劳动，帮助企业降低管理成本，提高效率</div>-->
<!--				</div>-->

<!--				<div>-->
<!--					<div><img src="../../assets/images/s3.png"></div>-->
<!--					<div class="title">数据化</div>-->
<!--					<div class="p">培训数据后台留存，帮助企业落实安全生产主体责任</div>-->
<!--				</div>-->
			</div>

      <p class="p">
        崇明软壳蟹工厂是识加科技携手上海海洋大学打造的智能化养殖基地，从环境构建、装备研发、技术革新到品
        质管控等各个环节，成功建立了包含大闸蟹蓄养、室内生产、蜕壳调控及品质控制等完善的软壳蟹生产技术体
        系，实现了工厂化生产。同时，该工厂将生产、科研、科普、示范与文旅功能融为一体，不仅为河蟹新型养殖
        形式和新产品业态树立了典型案例，也为其他水产对象的工业化生产提供了有力示范
      </p>
<!--			<ul>-->
<!--				<li><img src="../../assets/images/s4.png"></li>-->
<!--				<li><img src="../../assets/images/s5.png"></li>-->
<!--			</ul>-->
		</div>

    <Qrcode class="qrcode" text="扫码看视频介绍"/>

<!--		<div class="slide" id="slide1_2">-->
<!--			<h1>让AI改变驾驶安全<div></div></h1>-->
<!--			<h4>行车安全解决方案</h4>-->
<!--			<div id="mountNode"></div>-->
<!--			<div class="title">渣土建设交通事故率，逐年递减</div>-->
<!--		</div>-->
	</div>
</template>

<script>
	import Qrcode from "@/views/qrcode.vue";

  export default {
    components: {Qrcode}
  }
</script>

<style lang="scss"></style>
